import axios from "axios"

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMG,
})

AxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenDealerOMG")
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  try {
    const url = config.url || ""
    const method = (config.method || "get").toLowerCase()
    if (
      method === "post" &&
      url.includes("BigQuery/") &&
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      const sid = sessionStorage.getItem("domgBigQueryDealerId")
      if (sid !== null && sid !== "") {
        const id = Number(sid)
        if (
          !Number.isNaN(id) &&
          !Object.prototype.hasOwnProperty.call(config.data, "dealerId")
        ) {
          config.data = { ...config.data, dealerId: id }
        }
      }
    }
  } catch (_) {
    /* ignore */
  }
  return config
})

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      if (error.response.data?.status === "DENIED") {
        console.log("Redirecting")
        localStorage.removeItem("tokenDealerOMG")
        localStorage.removeItem("permissionsDealerOMG")
        window.location.href = "/"
      }
    }
    return error
  }
)

if (localStorage.getItem("tokenDealerOMG")) {
  AxiosInstance.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
    "tokenDealerOMG"
  )}`
}

export default AxiosInstance
